import React, { useEffect, useState } from 'react';
import { Row, Col, Card, Form, Button } from 'react-bootstrap';
import CsLineIcons from 'cs-line-icons/CsLineIcons';
import AutocompletePlaceholder from 'views/interface/forms/controls/autocomplete/AutocompletePlaceholder';
import DropzoneColumns from 'views/settings/components/DropzoneColumns';
import { observer } from 'mobx-react';
import * as Yup from 'yup';
import { GetUserRegistrationStore } from 'SessionState/Registration/UserRegistrationStore';
import { useFormik, useFormikContext } from 'formik';
import { Geography } from 'API/Generated/Geography';
import { ContestantUserBaseModel, IndustryStyleTypeModel, StateModel } from 'API/Generated/data-contracts';
import { IndustryStyleTypes } from 'API/Generated/IndustryStyleTypes';
import { byteArrayToFile } from 'helpers/fileHelpers';
import { CheckboxList } from 'components/forms/CheckboxList';
import Select from 'react-select';
// import { ImageUpload } from 'views/components/ImageUpload';
import ImageUpload from 'views/components/ImageUpload';
import { GetGeoStore } from 'SessionState/Geo/GeoStore';
import AutocompleteCustomRender from 'views/components/AutocompleteCustomRender';

export interface IAddEditContestantFormProps {
  contestant?: ContestantUserBaseModel;
  contestantIndex: number;
}

export const AddEditContestantForm = (observer((props: IAddEditContestantFormProps) => {

  const geoStore = GetGeoStore();

  const init = async () => {
    // let res = await geographyService.getStates();
    await geoStore.getStates();
  }
  useEffect(() => {
    init();
    console.log('values', values);
  }, [])

  const stateOptions = geoStore.StateList.map(x => { return { value: x.id,   label: `${x.name} (${x.abbreviation})`, } })

  const optionsGender = [
    { value: 1, label: 'Female' },
    { value: 2, label: 'Male' },
    { value: 3, label: 'Other' },
  ];

  const optionsFiling = [
    { value: 1, label: 'Single' },
    { value: 2, label: 'Married' },
    { value: 3, label: 'Divorced/Separated' },
  ];

  const competitionStatusOptions = [
    { value: 'Beginner', label: 'I have not competed before, just beginning!' },
    { value: 'Active', label: 'I am very actively competing.' },
    { value: 'Semi-Active', label: 'I am competing some.' },
    { value: 'Inactive', label: 'I am no longer competing.' }
  ]

  const { handleSubmit, handleChange, values, touched, errors } = useFormikContext<ContestantUserBaseModel>();

  return (
    <>
      {/* Contestants Add/Edit Form Start */}
      <Form>
        <Card className='mb-1'>
          <Card.Body className="mb-n5">
            <div className="d-flex align-items-center flex-column">
              <div className="position-relative mb-3">
              <h2 className="small-title text-center">Upload Headshot</h2>
                <Col md="6">
                  <ImageUpload image={values.profilePic?.image ?? undefined} containerName='contestant-profile-headshots'/>
                </Col>
              </div>
            </div>
            <Row className="mb-7">
              <Col md="6">
                <div className="mb-3 top-label">
                <label className="form-label text-danger">FIRST NAME <span className='text-danger'>*</span></label>
                  <Form.Control type="text" placeholder="First Name" name="firstName" onChange={handleChange} value={values.firstName ?? ''} />
                  {errors.firstName && touched.firstName && <div className="d-block invalid-tooltip">{`${errors.firstName}`}</div>}
                </div>
              </Col>
              <Col md="6">
                <div className="mb-3 top-label">
                <label className="form-label text-danger">LAST NAME <span className='text-danger'>*</span></label>
                  <Form.Control type="text" placeholder="Last Name" name="lastName" onChange={handleChange} value={values.lastName ?? ''} />
                  {errors.lastName && touched.lastName && <div className="d-block invalid-tooltip">{`${errors.lastName}`}</div>}
                </div>
              </Col>
              <Col md="6">
                <div className="mb-3 top-label">
                <label className="form-label text-danger">BIRTHDAY <span className='text-danger'>*</span></label>
                  <Form.Control type="date" placeholder="Birthday" name="birthday" onChange={handleChange} value={values.birthday ?? ''} />
                  {errors.birthday && touched.birthday && <div className="d-block invalid-tooltip">{`${errors.birthday}`}</div>}
                </div>
              </Col>
              <Col md="6">
                <div className="mb-3 top-label">
                  <label className="form-label text-danger">GENDER <span className='text-danger'>*</span></label>
                  <Select
                    classNamePrefix="react-select"
                    options={optionsGender}
                    value={optionsGender.find((obj) => obj.value === values.genderId)}
                    placeholder={<><CsLineIcons icon="gender" />Gender</>}
                    onChange={(selectedOption) => {
                      let event = { target: { name: "genderId", value: selectedOption?.value } }
                      handleChange(event)
                    }}
                  />
                  {errors.genderId && touched.genderId && <div className="d-block invalid-tooltip">{`${errors.genderId}`}</div>}
                </div>
              </Col>
              <Col md="6">
                <div className="mb-3 top-label">
                <label className="form-label">HAIR COLOR </label>
                  <Form.Control type="text" placeholder="Hair Color" name="hairColor" onChange={handleChange} value={values.hairColor ?? ''} />
                  {errors.hairColor && touched.hairColor && <div className="d-block invalid-tooltip">{`${errors.hairColor}`}</div>}
                </div>
              </Col>
              <Col md="6">
                <div className="mb-3 top-label">
                <label className="form-label">EYE COLOR </label>
                  <Form.Control type="text" placeholder="Eye Color" name="eyeColor" onChange={handleChange} value={values.eyeColor ?? ''} />
                  {errors.eyeColor && touched.eyeColor && <div className="d-block invalid-tooltip">{`${errors.eyeColor}`}</div>}
                </div>
              </Col>
              <Col md="6">
                <div className="mb-3 top-label">
                <label className="form-label text-danger">CITY <span className='text-danger'>*</span></label>
                  <Form.Control type="text" placeholder="City" name="city" onChange={handleChange} value={values.city ?? ''} />
                  {errors.city && touched.city && <div className="d-block invalid-tooltip">{`${errors.city}`}</div>}
                </div>
              </Col>
              <Col md="6">
                <div className="mb-3 top-label">
                  <Select
                    classNamePrefix="react-select"
                    value={stateOptions.find(x => x.value == values.stateId)}
                    options={stateOptions}
                    placeholder={<>State</>}
                    onChange={(selectedOption) => {
                      let event = { target: { name: "stateId", value: selectedOption?.value } }
                      handleChange(event);
                    }}
                  />
                   <label className="form-label text-danger">STATE <span className='text-danger'>*</span></label>
                  {errors.stateId && touched.stateId && <div className="d-block invalid-tooltip">{`${errors.stateId}`}</div>}
                </div>
              </Col>
              {/* <Col>
              <h2 className="small-title">Have A Coach?</h2>
            <Card body className="mb-5">
              <Row>
                <Col xs="12" lg="6">
                  <Form.Label>Add Coach</Form.Label>
                  <AutocompleteCustomRender />
                </Col>
              </Row>
            </Card>
              </Col> */}
                <div className="mb-3 top-label">
                <label className="form-label ">HOBBIES </label>
                  <Form.Control as="textarea" rows={3} placeholder="Hobbies" name="hobbies" onChange={handleChange} />
                  {errors.hobbies && touched.hobbies && <div className="d-block invalid-tooltip">{`${errors.hobbies}`}</div>}
                </div>
            </Row>
            {/* <Row>
              <Col md="6">
                <div className="mb-3">
                  <h5>Competition Status</h5>
                  {
                    competitionStatusOptions.map(x => {
                      return <Form.Check type="radio" name="competitionStatus" onChange={handleChange} value={x.value} label={x.label} key={x.value} />
                    })
                  }
                  {errors.competitionStatus && touched.competitionStatus && <div className="d-block invalid-tooltip">{`${errors.competitionStatus}`}</div>}
                </div>
              </Col>
              <Col md="6">
                <h5>Competition Start Year</h5>
                <div className="mb-3 filled">
                  <CsLineIcons icon="calendar" />
                  <Form.Control type="date" placeholder="Year Began Pageants" name="dateStartedCompeting" onChange={handleChange} />
                  {errors.dateStartedCompeting && touched.dateStartedCompeting && <div className="d-block invalid-tooltip">{`${errors.dateStartedCompeting}`}</div>}
                </div>
              </Col>
            </Row>
            <Row border="black" className="p-2">
              <Col md="6">
                <div className="mb-3">
                  <h5>Coach/Team Status</h5>
                  <Form.Check type="radio" label="I have a Coach" id="haveCoach" name="teamStatus" onChange={handleChange} value='Has Coach' />
                  <Form.Check type="radio" label="I am seeking a Coach" id="seekCoach" name="teamStatus" onChange={handleChange} value='Seeking Coach' />
                  <Form.Check type="radio" label="N/A" id="naCoach" name="teamStatus" onChange={handleChange} value='N/A' />
                  {errors.teamStatus && touched.teamStatus && <div className="d-block invalid-tooltip">{`${errors.teamStatus}`}</div>}
                </div>
              </Col>
              <Col md="6">
                <div className=" mb-3 filled">
                  <CsLineIcons icon="loaf" />
                  <AutocompletePlaceholder />
                </div>
              </Col>
            </Row>
            <Row border="black" className="p-2">
              <div className="mb-3">
                <h5>The style(s) of pageantry I am interested in</h5>
                <div role="group" aria-labelledby="checkbox-group">
                   {
                    allIndustryStyleTypes.map(x => {
                      return <Form.Check key={`${x.id}_${x.name}`} value={x.id} label={x.name} name="industryStyleTypeIds" defaultChecked={defaultSelectedIndustryTypeIds?.includes(`${x.id}`)} onChange={handleChange} />
                    })
                  } 
                  <CheckboxList value={values.industryStyleTypeIds} name="industryStyleTypeIds" handleChange={handleChange} options={allIndustryStyleTypes.map(x => { return {label: x.name, value: x.id}})} />
                  {errors.industryStyleTypeIds && touched.industryStyleTypeIds && <div className="d-block invalid-tooltip">{`${errors.industryStyleTypeIds}`}</div>}
                </div>
              </div>
            </Row> */}
          </Card.Body>
          {/* <Card.Footer>
            <Row>
              <Col>
                <div className="d-flex flex-row justify-content-between w-100 w-sm-50 w-xl-100">
                  <Button variant="outline-primary" className="w-100 me-2">
                    Cancel
                  </Button>
                </div>
              </Col>
              <Col md="8">
                <div className="d-flex flex-row justify-content-between w-100 w-sm-50 w-xl-100">
                  <Button variant="primary" className="w-100 me-2" type="submit">
                    Save Contestant
                  </Button>
                </div>
              </Col>
            </Row>
          </Card.Footer> */}
        </Card>
      </Form>
      {/* Contestant Add/Edit Form End */}
    </>
  );
}));

export default AddEditContestantForm;
